import { ReservationTimeState } from '@mews-commander/data-access';
import { ReservationAccountState } from '@mews-commander/guest-profile';

export enum MergeMode {
    Single = 'Single',
    Queue = 'Queue',
}

export enum ReservationState {
    Active = 'Active',
    Canceled = 'Canceled',
    Past = 'Past',
}

export interface GuestReservation {
    id: string;
    startUtc: string;
    endUtc: string;
    groupName: string;
    number?: string;
    state: ReservationState;
    timeState: ReservationTimeState;
    accountState?: ReservationAccountState;
    serviceId: string;
}
